__turbopack_context__.v({
  "className": "yethangul_c258451f-module__ZdMhYa__className",
  "variable": "yethangul_c258451f-module__ZdMhYa__variable",
});
